'use client';

import styles from './errorLayout.module.scss';
// -------------- icons -------------------- //
import ErrorBoxNew from '@/assets/icons/Error_BoxNew.svg';
import ErrorNetwork from '@/assets/icons/Error_Network.svg';
import ErrorSpaceship from '@/assets/icons/Error_Spaceship.svg';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BESTSELLERS_EVENT_NAMES,
  bestSellersBusinessLogger,
} from '@/utils/logger/instance/bestSellersBusinessLogger';

interface PropType {
  code: string;
}
const ErrorLayout = ({ code }: PropType) => {
  const router = useRouter();
  const { t } = useTranslation();

  const Error: {
    [key: string]: {
      text: string;
      btnText: string;
      handleClick: () => void;
      svg: JSX.Element;
    };
  } = {
    '-1': {
      text: t('bestSeller.recommend.noNetwork'),
      btnText: t('bestSeller.button.refresh'),
      svg: <ErrorNetwork />,
      handleClick: () => window.location.reload(),
    },
    NA: {
      text: t('bestSeller.recommend.errorText1'),
      btnText: t('bestSeller.button.backtoBestSeller'),
      svg: <ErrorBoxNew />,
      handleClick: () => (window.location.href = '/promo/best-seller'),
    },
    default: {
      text: t('bestSeller.recommend.tryAgain'),
      btnText: t('bestSeller.button.refresh'),
      svg: <ErrorSpaceship />,
      handleClick: () => window.location.reload(),
    },
  };

  useEffect(() => {
    bestSellersBusinessLogger({
      eventName: BESTSELLERS_EVENT_NAMES.INIT_CATEGORY_SIDE_FAIL,
      message: {
        code: code,
      },
    });
  }, []);

  const errorItem = Error[code] || Error.default;
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.errorTryAgain}>
          {errorItem.svg}
          <div className={styles.errorText}>{errorItem.text}</div>
          <button className={styles.errorButton} onClick={errorItem.handleClick}>
            <span>{errorItem.btnText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorLayout;
